<template>

    <fieldset id="authProxy" v-if="isSilent">
        <legend>アカウント認証用プロキシ(任意)</legend>
        <div>
            T-DASHのアカウント認証やウェブドライバーのダウンロードなどに使用するプロキシサーバを設定してください。<br>
        </div>
        <div class="form-warn">
            ■注意事項<br>
            1. この設定が必要かどうかはネットワーク管理者に確認してください。<br>
            2. XX_winコマンド、または非対話型で実行する時に、プロキシを使用する場合は必ず入力してください。<br>
            3. アドレスとポートが全て入力された時のみ、それら全てを設定するオプションが追加されます。<br>
            4. アドレスとポート、アカウント名、パスワードが全て入力された時のみ、それら全てを設定するオプションが追加されます。
        </div>
        <div class="form-area">
            <label for="authProxyAddress">・アドレス</label><br>
            <input type="text" class="input-text" id="authProxyAddress" v-model="inputedAuthProxy.address"
                name="authProxyAddress" @input="updateOpt" placeholder="xxx.xxx.xxx.xxx"><br>
            <label for="authProxyPort">・ポート番号</label><br>
            <input type="text" class="input-text" id="authProxyPort" v-model="inputedAuthProxy.port"
                name="authProxyPort" @input="updateOpt" placeholder="8888"><br>
            <label for="authProxyAccount">・アカウント</label><br>
            <input type="text" class="input-text" id="authProxyAccount" v-model="inputedAuthProxy.account"
                name="authProxyAccount" @input="updateOpt" placeholder="your_account"><br>
            <label for="authProxyPassword">・パスワード</label><br>
            <input type="text" class="input-text" id="authProxyPassword" v-model="inputedAuthProxy.password"
                name="authProxyPassword" @input="updateOpt" placeholder="your_password"><br>
        </div>
    </fieldset>
</template>

<script>
import { onMounted, reactive, watch } from 'vue';
import makeOpt from '@/js/makeOpt.js'
import cacheUtils from '@/js/cacheUtils';

export default {
    name: 'AuthProxyForm',
    props: {
        isSilent: { type: Boolean, default: true }
    },
    setup(props, { emit }) {
        // ###############
        // フォームデータ #
        // ###############
        const inputedAuthProxy = reactive({
            address: '',
            port: '',
            account: '',
            password: ''
        })

        // #############
        // コマンド生成 #
        // #############
        const updateOpt = async () => {
            // プロキシ
            const createdOpt = await makeOpt.createProxyOpt(
                "auth", inputedAuthProxy, props.isSilent
            )

            // cacheに保存
            await cacheUtils.saveData("authProxyAddress", inputedAuthProxy.address)
            await cacheUtils.saveData("authProxyPort", inputedAuthProxy.port)
            await cacheUtils.saveData("authProxyAccount", inputedAuthProxy.account)
            await cacheUtils.saveData("authProxyPassword", inputedAuthProxy.password)

            // コマンド生成&表示は親コンポーネント
            emit("update-opt", "authProxy", createdOpt)
        }

        // ############
        // propsの監視 #
        // * propsをcomputedに入れると無限に呼び出されるため、watchで関数を発火させる
        // ############
        // サイレントモード設定の監視
        watch(
            () => props.isSilent,
            async () => {
                await updateOpt()
            }
        )

        // ###############
        // ライフサイクル #
        // ###############
        onMounted(async () => {
            // cacheから取り出し
            inputedAuthProxy.address = await cacheUtils.getData("authProxyAddress")
            inputedAuthProxy.port = await cacheUtils.getData("authProxyPort")
            inputedAuthProxy.account = await cacheUtils.getData("authProxyAccount")
            inputedAuthProxy.password = await cacheUtils.getData("authProxyPassword")

            await updateOpt()
        })

        return {
            // フォームデータ
            inputedAuthProxy,
            // コマンド生成
            updateOpt,
        }
    }
}
</script>
